import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'eo-extra-points',
  templateUrl: './extra-points.component.html',
  styleUrls: ['./extra-points.component.css']
})
export class ExtraPointsComponent implements OnInit {

  @Input() points: any;
  @Input() position: any;

  constructor() { }

  ngOnInit() {
  }

}
